'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotLineMarkersIcon = function PlotLineMarkersIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M28.313 6.375c-1.5 0-2.75-1.188-2.688-2.75 0-1.5 1.188-2.75 2.75-2.688 1.5 0 2.75 1.188 2.688 2.75 0 1.5-1.188 2.75-2.75 2.688zm0-3.812c-.563 0-1.063.5-1.063 1.125 0 .563.5 1.063 1.063 1.063.625 0 1.063-.5 1.063-1.063 0-.625-.438-1.125-1.063-1.125zm-24.625 28.5c-1.563.063-2.75-1.188-2.75-2.688-.063-1.563 1.188-2.75 2.688-2.75 1.563-.063 2.75 1.188 2.75 2.688.063 1.563-1.188 2.75-2.688 2.75zm0-3.813c-.625 0-1.063.5-1.063 1.125 0 .563.438 1.063 1.063 1.063.563 0 1.063-.5 1.063-1.063 0-.625-.5-1.125-1.063-1.125zm1.375.188l-1.5-.75 5.063-9.375 3.25 6.125 8.188-17 3.25 6.125 3.625-8 1.563.75-5 11.063-3.375-6.25-8.188 17-3.375-6.25z' })
    );
};

exports.default = PlotLineMarkersIcon;